import { render, staticRenderFns } from "./lgorder.vue?vue&type=template&id=59f60f23&"
import script from "./lgorder.vue?vue&type=script&lang=js&"
export * from "./lgorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports